import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-card',
  templateUrl: './card.component.html',
  standalone: false,
})
export class CardComponent {
  @HostBinding('class') styles = 'block w-full rounded-xl shadow bg-base border border-gray-200';
}
